import type { AxiosError } from "axios";

import type { ApiResponse } from "@/types/api";

const DEFAULT_ERROR_MESSAGE = "Something went wrong. Please try again.";

export function extractApiError(error: unknown): string {
    if (typeof error === "string") {
        return error;
    }

    const axiosError = error as AxiosError<ApiResponse>;

    // Network error (no response from server)
    if (axiosError.code === "ERR_NETWORK" || axiosError.message === "Network Error") {
        return "Network error: Could not connect to the server. Please check if the backend is running.";
    }

    // Request timeout
    if (axiosError.code === "ECONNABORTED") {
        return "Request timeout: The server took too long to respond.";
    }

    // Server responded with error
    const responseMessage = axiosError.response?.data?.message;
    if (responseMessage) {
        return responseMessage;
    }

    // HTTP status code errors
    if (axiosError.response?.status) {
        const status = axiosError.response.status;
        if (status === 404) {
            return "Endpoint not found. Please check the API endpoint.";
        }
        if (status >= 500) {
            return "Server error. Please try again later.";
        }
    }

    // Generic error message
    if (error instanceof Error && error.message) {
        return error.message;
    }

    return DEFAULT_ERROR_MESSAGE;
}

